import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map, Observable } from 'rxjs';
import { Token } from '@angular/compiler';
import { Router } from '@angular/router';
import { ApiService } from './api-service';
import Swal from 'sweetalert2'
import { JwtService } from './jwt.service';



@Injectable({
  providedIn: 'root',
})

export class UserService {

  userID: any;
  userFirstName: any;
  userLastName: any;

  constructor(
    private api: ApiService,
    private router: Router,
    private ngZone: NgZone,
    private http: HttpClient,
    private jwt: JwtService

    ) {
  }

  userData: any;

  register(body) {
    const url = `/Applicant/Register`;
    return this.api.post(url, body);
  }

  login(body) {
    const url = `/Applicant/Login`;
    return this.api.post(url, body)
  }

  googleLogin(body) {
    const url = '/Applicant/GoogleAuth'
    return this.api.post(url, body)
  }

  
  getLoginProvider(email){
    const url = `/Applicant/GetLoginProvider?email=${email}`
    return this.api.get(url)

  }

  setUserID(id: any) {
    this.userID = id;
  }

  setUserFirstName(userFirstName: any) {
    this.userFirstName = userFirstName;
  }

  setUserLastName(userLastName: any) {
    this.userLastName = userLastName;
  }

  resendEmailVerification(email) {
    const url = `/Applicant/ResendEmailVerification`;
    const params = { email: email }; 
    return this.api.postUrl(url, null, params);
  }
  
  resetPassword(email) {
    const url = '/Applicant/ResetPassword'
    const params = { email: email }; 
    return this.api.postUrl(url, null, params);
  }

  changePassword(){
    
  }
  
  updateApplicantDetails(body){
    const url = '/Applicant/UpdateApplicant'
    return this.api.post(url, body);
  }

  getApplicantDetails(id){
    const url = `/Applicant/GetApplicant?Id=${id}`
    return this.api.get(url);
  }

  postFile(body){
    const url = `${environment.apiUrl}/Main/UploadFile`
    return this.api.postFile(url, body);
    
  } 

  languagePreferences(id, body) {
    const url = `/Applicant/settings/${id}/preferred-language`;
    return this.api.putUrl(url, body);
  }

  getUserSettings(id){
    const url = `/Applicant/settings/${id}`;
    return this.api.get(url).pipe(
      map((data: any) => {
        return data;
      })
    );
  }
  

}
